import React, { FC } from 'react';
import { HeadFC, PageProps, graphql } from 'gatsby';

import View from '../views/404';
import Layout from '../components/Layout';
import SEO from '../components/Head';
import { PageContext } from '../../gatsby-node';

const Page: FC<PageProps<Queries.ErrorPageQueryQuery, PageContext>> = props => {
  const {
    data,
    pageContext: { locale },
  } = props;

  return (
    <Layout>
      <View data={data} locale={locale} />
    </Layout>
  );
};

export const Head: HeadFC<Queries.ErrorPageQueryQuery, PageContext> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query ErrorPageQuery($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/404/**" }) {
      childJson {
        ...Meta
        ...SeoNavbar
        ...ErrorContent
        ...SeoFooter
      }
    }
  }
`;

export default Page;
